'use strict';
var latestServices = {
    messagecenter:   'mc-1',
    ecom:            'ecom-4',
    identity:        'identity-3',
    inventory:       'inventory-3',
    logistics:       'logistics-2',
    cms:             'cms-service',
    usercomm:        'usercomm',
    boss:            'boss-1',
    trade:           'trade-1',
    media:           'media-1',
    analytics:       'analytics-1'
};
module.exports = {
    latestServices: latestServices,
    latest: {
        messagecenter:       latestServices.messagecenter + '/1',   // mc-1/1
        mcFlagMessage:       latestServices.messagecenter + '/2',   // mc-1/2

        ecom:                latestServices.ecom + '/2',            // ecom-4/2',
        ecomPromotion:       latestServices.ecom + '/3',            // ecom-4/3,
        ecomTransaction:     latestServices.ecom + '/3',            //'ecom-4/3',
        ecomSummary:         latestServices.ecom + '/4',            //'ecom-4/4',
        ecomLogistics:       latestServices.ecom + '/4',            //'ecom-4/4',
        ecomCurrency:        latestServices.ecom + '/3',            //'ecom-4/3',

        identity:               latestServices.identity + '/1',     //'identity-3/1',
        identityShipping:       latestServices.identity + '/2',     //'identity-3/2',
        identityHyperwallet:    latestServices.identity + '/2',     //'identity-3/2',
        identityLogistics:      latestServices.identity + '/4',     //'identity-3/4',
        identitySocialNetworks: latestServices.identity + '/2',     //'identity-3/2',
        identityTrade:          latestServices.identity + '/2',     //'identity-3/2',
        identityOauth:          latestServices.identity + '/2',     //'identity-3/2',
        trade:                  latestServices.trade + '/2',        //'trade-1/2',
        identityConvNotes:      latestServices.identity + '/2',     //'identity-3/2',

        inventory:           latestServices.inventory + '/2',       //'inventory-3/2',
        inventoryItem:       latestServices.inventory + '/3',       //'inventory-3/3',
        inventoryAttributes: latestServices.inventory + '/1',       // inventory-3/1
        inventoryShipping:   latestServices.inventory + '/2',       // 'inventory-3/2',
        inventoryLogistics:  latestServices.inventory + '/4',       // 'inventory-3/4',
        inventoryCreators:   latestServices.inventory + '/2',       // 'inventory-3/2',
        inventoryCategories: latestServices.inventory + '/3',       // 'inventory-3/3',
        inventoryFileUpload: latestServices.inventory + '/3',       // 'inventory-3/3',
        inventoryReviews:    latestServices.inventory + '/2',       // 'inventory-3/3',
        inventoryListings:   latestServices.inventory + '/2',       // 'inventory-3/3',

        logistics:           latestServices.logistics + '/3',       //'logistics-2/3',
        logisticsShipping:   latestServices.logistics + '/4',       //'logistics-2/4'

        analytics:           latestServices.analytics + '/2',       //'analytics-1/2'

        cms:                 latestServices.cms + '/v1',

        usercomm:            latestServices.usercomm + '/2',

        boss:                latestServices.boss + '/1',

        media:               latestServices.media + '/2'
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/~/dibs-endpoints/versions.js
// module id = 2659
// module chunks = 64